import { useRouter } from '@/routing/useAppRouter';

import { LanguageType } from '@/types/language';

/**
 * 현재 언어 타입 가져오는 hook
 * @returns {string} currentLang
 */
export default function useCurrentLang(): 'en' | 'ko' {
  const router = useRouter();
  const currentLang = (router.locale || 'en') as LanguageType;

  return currentLang;
}
